import { FALLBACK_LOCALE, isLocale } from '@/libraries/getters/get-locale';

/**
 * in Umbraco language versioning, there exists Culture, but also there is the 'Slug', before, we treat these as the same thing,
 * but in the Staging, the client made the language Slug different from Culture, whereas we only take "da-DK" as both the slug and the culture.
 * So to solve, below is mapping of locale and culture i.e: "da" and "da-DK" respectively.
 */
export const SUPPORTED_CULTURES: Record<Locale, Culture> = {
  da: 'da-DK',
  en: 'en-US',
  nb: 'nb-NO',
  sv: 'sv-SE',
};

const getCulture = (locale?: string): Culture => {
  if (locale && isLocale(locale)) {
    return SUPPORTED_CULTURES[locale];
  }

  if (isLocale(process.env.NEXT_PUBLIC_DEFAULT_LOCALE)) {
    return SUPPORTED_CULTURES[process.env.NEXT_PUBLIC_DEFAULT_LOCALE];
  }

  return SUPPORTED_CULTURES[FALLBACK_LOCALE];
};

export default getCulture;
